export default function ScoreDisplay({ score, max }) {
  const pct = Math.min(Math.max(score / max, 0), 1) * 100;
  const cls = getScoreColorClass(score, max);

  return (
    <div className="score-display">
      <div className="score-display-numbers">
        <span className={`score-display-number ${cls}`}>{score}</span>
        <span className="score-display-max">/ {max}</span>
      </div>
      <div className="score-display-bar">
        <div className={`score-display-bar-fill ${cls}`} style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}

function getScoreColorClass(score, max) {
  const pct = (score / max) * 100;
  if (pct >= 80) return 'score-high';
  if (pct >= 60) return 'score-qualified';
  if (pct >= 40) return 'score-low';
  return 'score-invalid';
}
